import * as React from 'react';
import { DateFormats, formatDate, parseDate } from 'src/utils/time';
import styled from 'styled-components';

interface MessageAuthorAndTimeProps {
  timestamp: string;
  author: string;
}

export const MessageAuthorAndTime: React.FC<MessageAuthorAndTimeProps> = ({
  timestamp,
  author,
}) => {
  const parsedTimestamp = parseDate(timestamp, DateFormats.ISO);

  return (
    <MessageAuthorAndTimeStyled>
      {author}{' '}
      {formatDate(
        parsedTimestamp,
        DateFormats.TIME_SHORT_DD_MMM_YYY,
        false,
      ).toUpperCase()}
    </MessageAuthorAndTimeStyled>
  );
};

const MessageAuthorAndTimeStyled = styled.div`
  padding-top: 4px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 500;
  font-size: 7px;
  color: ${(props) => props.theme.atlas.semantic.color.outline.default};
  text-transform: uppercase;
`;
